import { throttle } from "@/utils/fn";
import React, { useEffect, useRef } from "react";
import initPreview from "./initPreview.js";
import { ChatWindow } from "@/pages/Messaging/ChatWindow/types.js";

interface Props {
  type: string;
  workingChatWindow: ChatWindow;
  aiConfigId?: string;
}

export default function Preview(props: Props) {
  const el = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (el.current) {
      initPreview(el.current);
    }

    return () => {
      (window as any).MessengerPreview?.call("destroy");
      (window as any).MessengerPreview = undefined;
      (window as any).__messenger_preview = undefined;
      document.getElementById("messenger-preview-script")?.remove();
    };
  }, []);

  const sendUpdate = useRef(
    throttle((chatWindow: ChatWindow) => {
      const mp = (window as any).MessengerPreview;
      if (!mp || !chatWindow) return;
      mp.call("updateChatWindow", chatWindow);
    }, 25)
  );

  useEffect(() => {
    sendUpdate.current(props.workingChatWindow);
  }, [props.workingChatWindow]);

  useEffect(() => {
    const mp = (window as any).MessengerPreview;

    if (mp && props.type) {
      mp.call("updatePreview", props.type);
    }
  }, [props.type]);

  useEffect(() => {
    const mp = (window as any).MessengerPreview;

    if (mp && props.aiConfigId) {
      mp.call("updateAiConfigId", props.aiConfigId);
    }
  }, [props.aiConfigId]);

  return <div ref={el}></div>;
}
